/* Silph TCG — carrousel « Vous aimerez aussi » avec boucle.
   Custom element : se câble automatiquement quand product-recommendations injecte
   son HTML (AJAX). Les flèches défilent d'une « page » ; arrivées au bout, elles
   reviennent au début (et inversement) → défilement en boucle. */
if (!customElements.get('silph-loop-slider')) {
  class SilphLoopSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      if (!this.track || !this.nextBtn || this._wired) return;
      this._wired = true;
      this.nextBtn.addEventListener('click', () => this.advance(1));
      this.prevBtn.addEventListener('click', () => this.advance(-1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      this.updateArrows();
    }

    get maxScroll() {
      return this.track.scrollWidth - this.track.clientWidth;
    }

    advance(dir) {
      // une « page » = la largeur visible = exactement 4 produits → 3 slides
      const page = this.track.clientWidth;
      const max = this.maxScroll;
      const current = this.track.scrollLeft;
      let target;
      if (dir > 0) {
        target = current >= max - 5 ? 0 : Math.min(max, current + page);
      } else {
        target = current <= 5 ? max : Math.max(0, current - page);
      }
      this.track.scrollTo({ left: target, behavior: 'smooth' });
    }

    updateArrows() {
      // les flèches restent toujours actives (boucle), on ne les désactive pas
    }
  }
  customElements.define('silph-loop-slider', SilphLoopSlider);
}
